export { default as NSlider, sliderProps } from './src/Slider';
